import { t } from 'i18next';

import { setError } from './statusItemsSlice';

import { handleApiError } from '@/api';
import { addNotification } from '@/redux/slices/notificationSlice';

export const ERROR_MESSAGES = {
  LOAD_FAILED: 'load_failed',
  GET_DEPOTS_FAILED: 'get_depots_failed',
} as const;

export const createErrorHandler =
  (messageKey: string) =>
  async (_args: any, { dispatch, queryFulfilled }: any) => {
    try {
      await queryFulfilled;
    } catch (error: any) {
      const errorMessage = handleApiError(t, error);
      dispatch(setError(errorMessage.data.detail));
      dispatch(
        addNotification({
          type: 'error',
          message: t(`health_check.${messageKey}`),
          description: errorMessage.data.detail,
        })
      );
    }
  };
